<template>
  <div class="change-order-cards" v-if="filtered.length > 0">
    <input type="file" ref="fileInput" multiple @change="onFileChange" style="display: none;" />
    <v-data-iterator :items="filtered">
      <template v-slot:default="props">
        <v-row>
          <v-col v-for="item in props.items"
                 :key="item.id"
                 cols="12"
                 sm="6"
                 md="6"
                 lg="6">
            <v-card class="pb-2">
              <div class="float-right">
                <v-btn @click="selectFile(item)"
                       color="accent"
                       height="40"
                       width="40"
                       icon
                       dark
                       small>
                  <v-icon size="32"> mdi-upload</v-icon>
                </v-btn>
                <v-btn @click="cardDialog(item)"
                       color="error"
                       height="40"
                       width="40"
                       icon
                       dark
                       small>
                  <v-icon size="32"> mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-title>
                <h4>{{item.id}} - {{item.status}}</h4>
              </v-card-title>
              <div v-if="item.user != null">
                <v-flex class="ml-4 mb-2">
                  <p>Updated by: {{item.user.firstName}} {{item.user.lastName}}</p>
                </v-flex>
              </div>
              <div class="px-4 pb-2">
                <v-textarea outlined clearable auto-grow v-model="item.description" label="Notes" rows=1 @change="update(item)"></v-textarea>
                <div v-for="(document, index) in item.documents" :key="index">
                  <v-row>
                    <v-col cols=5>
                      {{document.fileName}}
                    </v-col>
                    <v-col cols="4" class="text-right">
                      {{document.status}}
                    </v-col>
                    <v-col cols="3" class="text-right">
                      <td style="float: right;">
                        <v-icon color="accent"
                                style="padding-right: 10px;"
                                @click="downloadDoc(document)">visibility</v-icon>
                        <v-icon color="error"
                                @click="documentDialog(document)">mdi-trash-can-outline</v-icon>
                      </td>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div v-if="item.status === 'Submitted'">
                <v-flex class="text-right mr-2 mb-0">
                  <v-flex style="display:inline-flex;">
                    <v-checkbox style="margin-right:7px" success id="yesValue" label="Approved" @change="checkedMethod(item, 'Approved')"></v-checkbox>
                    <v-checkbox style="margin-left:7px" error id="noValue" label="Rejected" @change="checkedMethod(item, 'Rejected')"></v-checkbox>
                  </v-flex>
                </v-flex>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <template>
          <v-row justify="center">
            <v-dialog v-model="deleteDocumentConfirmDialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline pt-1 pr-1">
                  Confirm Deletion
                  <v-spacer></v-spacer>
                  <v-btn icon @click="deleteDocumentConfirmDialog = false"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pb-1"> Are you sure you want to delete this document? If it is the last attached, the card will also be removed.</v-card-text>
                <v-alert v-if="error !=null" color="error" dark><v-icon size="20" dark>warning</v-icon>Error removing document.</v-alert>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn outlined color="error" @click="deleteDocumentMethod(deleteDoc)">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </template>
    </v-data-iterator>
    <template>
      <v-row justify="center">
        <v-dialog v-model="deleteCardConfirmDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline pt-1 pr-1">
              Confirm Deletion
              <v-spacer></v-spacer>
              <v-btn icon @click="deleteCardConfirmDialog = false"><v-icon>close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pb-1"> Deleting this change order will also remove all attached files.</v-card-text>
            <v-alert v-if="error !=null || errorChangeOrder !=null" color="error" dark><v-icon size="20" dark>warning</v-icon>There was an error removing this change order.</v-alert>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn outlined color="error" @click="deleteCardMethod(deleteCard)">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-snackbar v-model="showMessage" color="error">
      Error uploading document to existing change order
      <v-btn icon color="white" text @click="showMessage = false, clearAllErrors()">
        <v-icon size="28">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ChangeOrderCards',
  props: {
    stage: {
      type: String,
      default: null
    }
  },
  data: () => ({
    deleteDoc: null,
    deleteCard: null,
    deleteDocumentConfirmDialog: false,
    deleteCardConfirmDialog: false,
    changeOrderUploadTo: null,
    newStatus: '',
    file: null,
    fileName: null,
    submitError: null,
    checked: null,
    files: [],
    snackBar: false,
    uploadingCard: null,
    showMessage: false
  }),
  methods: {
    ...mapActions({
      loadChangeOrders: 'changeOrder/loadByTask',
      delete: 'changeOrderDocument/delete',
      getFile: 'changeOrderDocument/getFile',
      clearErrors: 'changeOrderDocument/clearErrors',
      clearChangeOrderErrors: 'changeOrder/clearErrors',
      updateChangeOrder: 'changeOrder/updateChangeOrder',
      deleteChangeOrder: 'changeOrder/deleteChangeOrder',
      uploadCreateChangeDoc: 'changeOrderDocument/uploadCreate'
    }),
    onFileChange (e) {
      this.files = e.target.files || e.dataTransfer.files
      this.upload()
      e.target.value = ''
    },
    selectFile (item) {
      // need to clear errors as well , and need spinner -loading somewhere
      this.clearErrors()
      this.clearChangeOrderErrors()
      this.changeOrderUploadTo = item
      this.$refs.fileInput.click()
    },
    async upload () {
      this.uploadingCard = this.changeOrderUploadTo.id

      // document object to upload to card
      let newDoc = {
        changeOrderId: this.changeOrderUploadTo.id,
        userId: this.id,
        file: null,
        status: this.changeOrderUploadTo.status
      }
      for (let file of this.files) { // upload documents to change order card
        this.fileName = file.name
        newDoc.file = file
        await this.uploadCreateChangeDoc(newDoc)
      }

      if (this.error != null) {
        this.showMessage = true
      }

      this.loadChangeOrders(this.changeOrderUploadTo.workOrderTaskId)
      this.filename = null
      this.uploadingCard = null
    },
    async checkedMethod (item, status) {
      this.changeOrderUploadTo = item
      this.changeOrderUploadTo.status = status

      await this.update(this.changeOrderUploadTo)

      this.loadChangeOrders(this.task.id)
      this.clearInfo()
    },
    clearInfo () {
      this.fileName = null
      this.file = null
      this.newStatus = ''
      this.changeOrderUploadTo = null
      this.submitted = false
    },
    async downloadDoc (document) {
      await this.getFile(document)
    },
    async update (changeOrder) {
      await this.updateChangeOrder(changeOrder)
    },
    async documentDialog (document) {
      this.deleteDoc = document
      this.clearAllErrors()
      this.deleteDocumentConfirmDialog = true
    },
    async cardDialog (changeOrder) {
      this.deleteCard = changeOrder
      this.clearAllErrors()
      this.deleteCardConfirmDialog = true
    },
    async deleteDocumentMethod (deleteDoc) {
      var emptyCheck = false
      await this.delete(deleteDoc.id)

      if (this.error == null) { // check if the card is now empty
        await this.loadChangeOrders(this.task.id)
        emptyCheck = this.cardIsEmpty(deleteDoc.changeOrderId)
      }

      if (emptyCheck) { //  if it is empty delete the card
        await this.deleteChangeOrder(deleteDoc.changeOrderId)
      } else {
        this.deleteDoc = null
        this.deleteDocumentConfirmDialog = false
        await this.loadChangeOrders(this.task.id)
      }

      if (this.error == null && this.errorChangeOrder == null) {
        this.deleteDocumentConfirmDialog = false
        await this.loadChangeOrders(this.task.id)
        this.deleteDoc = null
      }
    },
    async deleteCardMethod (deleteCard) {
      if (deleteCard.documents.length === 0) {
        this.deleteChangeOrder(deleteCard.id)
      } else {
        deleteCard.documents.forEach(this.deleteDocumentMethod)
      }

      if (this.error == null && this.errorChangeOrder == null) {
        this.deleteCardConfirmDialog = false
        await this.loadChangeOrders(this.task.id)
        this.deleteDoc = null
        this.deleteCard = null
      }
    },
    cardIsEmpty (cardId) {
      var check = false
      this.changeOrders.forEach(item => {
        if (cardId === item.id && (item.documents === undefined || item.documents.length === 0)) {
          check = true
        }
      })
      return check
    },
    clearAllErrors () {
      this.clearErrors()
      this.clearChangeOrderErrors()
    }
  },
  computed: {
    ...mapGetters({
      id: 'user/id',
      task: 'workOrderTask/selectedTask',
      changeOrders: 'changeOrder/changeOrdersByTask',
      error: 'changeOrderDocument/error',
      errorChangeOrder: 'changeOrder/error'
    }),
    filtered () {
      return this.changeOrders.filter((document) => {
        if (document.stageCreatedAt === this.stage) {
          return document
        }
      })
    }
  }
}
</script>
<style>
  .upload-container {
    padding: 20px 0;
    background-color: #f8f8f8;
    border-radius: 4px;
  }
</style>
